import "./rating_reviews.scss"
